"use client";

import Link from "next/link";
import { ThemeToggle } from "@/components/theme-toggle";
import { LanguageToggle } from "@/components/language-toggle";
import { useLanguage } from "@/contexts/language-context";

export function Header() {
  const { t } = useLanguage();

  return (
    <header className="px-6 h-16 flex items-center border-b border-gray-100 dark:border-gray-800 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center">
        <Link href="/" className="font-bold text-xl text-blue-600 dark:text-blue-500 tracking-tight flex items-center gap-2 group">
           {/* Logo SVG (SR Style) */}
           <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="transform group-hover:scale-110 transition-transform duration-300">
              <rect width="40" height="40" rx="10" fill="currentColor" className="text-blue-600 dark:text-blue-500"/>
              <path d="M10 14H20C22.2091 14 24 15.7909 24 18V18C24 20.2091 22.2091 22 20 22H10V14Z" stroke="white" strokeWidth="3"/>
              <path d="M10 22H16" stroke="white" strokeWidth="3"/>
              <path d="M16 22L22 28" stroke="white" strokeWidth="3" strokeLinecap="round"/>
              <path d="M28 14V28" stroke="white" strokeWidth="3" strokeLinecap="round"/>
              <path d="M28 21H34" stroke="white" strokeWidth="3" strokeLinecap="round"/>
            </svg>
          SRHelper <span className="text-gray-400 dark:text-gray-500 font-normal text-sm ml-1">Professional</span>
        </Link>
        <div className="flex items-center gap-4">
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600 dark:text-gray-300">
            <Link href="/features" className="hover:text-blue-600 dark:hover:text-blue-400 transition">
              {t.nav.features}
            </Link>
            <Link href="/pricing" className="hover:text-blue-600 dark:hover:text-blue-400 transition">
              {t.nav.pricing}
            </Link>
            <Link href="/enterprise" className="hover:text-blue-600 dark:hover:text-blue-400 transition">
              {t.nav.enterprise}
            </Link>
          </nav>
          <div className="h-4 w-px bg-gray-200 dark:bg-gray-700 hidden md:block"></div>
          <LanguageToggle />
          <ThemeToggle />
          <Link
            href="/upload"
            className="bg-gray-900 hover:bg-black dark:bg-white dark:text-black dark:hover:bg-gray-200 text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition shadow-sm"
          >
            {t.nav.start}
          </Link>
        </div>
      </div>
    </header>
  );
}
